import React, { useEffect, useContext, useState } from 'react';
import { Card, Row, Col, Form, InputGroup, FormControl } from 'react-bootstrap';
import '../participantList/participantList.css'
import { Typography } from '@mui/material';
import axios from 'axios';
import UserContext from '../../Context/User/userContext.jsx';
import { useNavigate } from 'react-router-dom';

const Sites = ({ setShowSpinner }) => {
    const [searchTerm, setSearchTerm] = useState(''); // State for search term
    const [searchBy, setSearchBy] = useState('name'); // State for search criterion
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate();
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSearchByChange = (e) => {
        setSearchBy(e.target.value);
    };


    const [participants, setParticipants] = useState([]);

    //Bearer Token
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : "";
    const getData = () => {
        setShowSpinner(true);
        axios.get('https://research-mate-b35a10757d5a.herokuapp.com/api/auth/users/true', {
            headers: {
                'Authorization': `Bearer ${tokenValue}`
                // You can add other headers if needed like authorization token, etc.
            }
        })
            .then(res => {
                // Handle success
                setParticipants(res.data.data);
                setShowSpinner(false);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }

    const searchUsers = () => {
        setShowSpinner(true);
        let obj;
        if (searchTerm == "") {
            obj = {
                approvedByAdmin: true
            };
        } else if (searchBy === "email") {
            obj = {
                email: searchTerm,
                approvedByAdmin: true
            };
        } else if (searchBy === "country") {
            obj = {
                country: searchTerm,
                approvedByAdmin: true
            };
        } else if (searchBy === "organizationName") {
            obj = {
                organizationName: searchTerm,
                approvedByAdmin: true
            };
        } else if (searchBy === "organizationType") {
            obj = {
                organizationType: searchTerm,
                approvedByAdmin: true
            };
        }
        // searchUsers
        axios.post('https://research-mate-b35a10757d5a.herokuapp.com/api/auth/searchUsers', obj, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${tokenValue}`
                // You can add other headers if needed like authorization token, etc.
            }
        })
            .then(res => {
                // Handle success
                setParticipants(res.data.data);
            })
            .catch(error => {
                console.log("Error:", error.response.data.message);
            })
            .finally(() => {
                setShowSpinner(false);
            })
    }

    const handleSiteClick = (userData) => {
        localStorage.setItem('siteUser', JSON.stringify(userData));
        setUser(userData);
        navigate('/home')
    }

    useEffect(() => {
        if (user) {
            getData()
        }
    }, [user])

    return (
        <div className='p-2'>
            <div className='d-flex justify-content-between align-items-center'>
                <div>
                    <Typography sx={{ color: '#169a8f', fontWeight: '600', fontFamily: 'nunito', marginBottom: '20px' }} variant="h4" gutterBottom>
                        Organizations <span className='badge'>{participants.length}</span>
                    </Typography>
                </div>
                <div>
                    <InputGroup className="mb-3">
                        <FormControl
                            placeholder="Search..."
                            aria-label="Search"
                            aria-describedby="basic-addon2"
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                        <Form.Select aria-label="Search by" value={searchBy} onChange={handleSearchByChange}>
                            <option value="organizationName">Organization Name</option>
                            <option value="organizationType">Organization Type</option>
                            <option value="country">Country</option>
                            <option value="email">Email</option>
                        </Form.Select>
                        <input className="btn btn-primary" style={{ backgroundColor: '#169a8f', border: 'none' }} type="button" value="Search" onClick={searchUsers}></input>
                    </InputGroup>
                </div>
            </div>
            <div className='sitegrid-custom'>
                {participants.map((participant, index) => (
                    <Card className='mt-2' key={index}>
                        <Card.Body onClick={e => handleSiteClick(participant)} style={{ cursor: 'pointer' }}>
                            <Row>
                                <Col style={{ maxWidth: '300px' }}>
                                    <h6>Name</h6>
                                    {/* <Link style={{ textDecoration: "none" }} to={`/home`}> */}
                                    <p className="ellipsis-text" title={participant.firstName + participant.lastName}>{participant.firstName} {participant.lastName}</p>
                                    {/* </Link> */}
                                </Col>
                                <Col style={{ maxWidth: '300px' }}>
                                    <h6>Organization Name</h6>
                                    <p  className="ellipsis-text" title={participant.organizationName}>
                                        {participant.organizationName}
                                    </p>
                                </Col>
                                <Col style={{ maxWidth: '300px' }}>
                                    <h6>Organization Type</h6>
                                    <p className="ellipsis-text" title={participant.organizationType}>
                                        {participant.organizationType}
                                    </p>
                                </Col>
                                <Col style={{ maxWidth: '300px' }}>
                                    <h6>Country</h6>
                                    <p className="ellipsis-text" title={participant.country}>
                                        {participant.country}
                                    </p>
                                </Col>
                                <Col style={{ maxWidth: '300px' }}>
                                    <h6>City</h6>
                                    <p className="ellipsis-text" title={participant.city}>
                                        {participant.city}
                                    </p>
                                </Col>
                                <Col style={{ maxWidth: '300px' }}>
                                    <h6>Email</h6>
                                    <p className="ellipsis-text" title={participant.email}>
                                        {participant.email}
                                    </p>
                                </Col>

                                {/* <Col style={{ maxWidth: '300px' }}>
                                    <h6>Organization Name</h6>
                                    <p>{participant.organizationName}</p>
                                </Col>
                                <Col style={{ maxWidth: '300px' }}>
                                    <h6>Organization Type</h6>
                                    <p>{participant.organizationType}</p>
                                </Col>
                                <Col style={{ maxWidth: '300px' }}>
                                    <h6>Country</h6>
                                    <p>{participant.country}</p>
                                </Col>
                                <Col style={{ maxWidth: '300px' }}>
                                    <h6>City</h6>
                                    <p>{participant.city}</p>
                                </Col>
                                <Col style={{ maxWidth: '300px' }}>
                                    <h6>Email</h6>
                                    <p>{participant.email}</p>
                                </Col> */}
                            </Row>
                        </Card.Body>
                    </Card>
                ))}

            </div>
        </div>
    );
};

export default Sites;
